<div class="back-navigation">
  <a (click)="back()" class="link">{{ navigationTitle | translate }}</a>
  <div *ngIf="pageSubTitle" class="splitter">/</div>
  <a (click)="back()" *ngIf="pageSubTitle" class="link">{{ pageSubTitle | translate }}</a>
  <div class="splitter">/</div>
  <div [class.no-transform]="noTextTransform" class="page-title">{{ pageTitle | translate }}</div>
</div>
